export default {
  apiKey: 'AIzaSyDFqEKhb0Ac0bJTvkftlmi0oNVY5t1500o',
  authDomain: 'ofoosboard.firebaseapp.com',
  databaseURL: 'https://ofoosboard.firebaseio.com',
  projectId: 'ofoosboard',
  storageBucket: 'ofoosboard.appspot.com',
  messagingSenderId: '913166784999'
}
